import { ChainId } from '@shared/utils/config/networks';
export const stableCoins = [{
  name: 'usdc',
  networks: [ChainId.SOLANA, ChainId.BASE, ChainId.AVALANCHE, ChainId.OPTIMISM, ChainId.ARBITRUM, ChainId.POLYGON, ChainId.ETHEREUM, ChainId.SUI],
  tokens: {
    [ChainId.SOLANA]: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v',
    [ChainId.BASE]: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
    [ChainId.AVALANCHE]: '0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E',
    [ChainId.OPTIMISM]: '0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85',
    [ChainId.ARBITRUM]: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
    [ChainId.POLYGON]: '0x3c499c542cef5e3811e1192ce70d8cc03d5c3359',
    [ChainId.ETHEREUM]: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
    [ChainId.SUI]: '0xdba34672e30cb065b1f93e3ab55318768fd6fef66c15942c9f7cb846e2f900e7::usdc::USDC'
  }
}, {
  name: 'usdt',
  networks: [ChainId.SOLANA, ChainId.BSC, ChainId.AVALANCHE, ChainId.OPTIMISM, ChainId.ARBITRUM, ChainId.POLYGON, ChainId.ETHEREUM],
  tokens: {
    [ChainId.SOLANA]: 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB',
    [ChainId.BSC]: '0x55d398326f99059ff775485246999027b3197955',
    [ChainId.AVALANCHE]: '0x9702230A8Ea53601f5cD2dc00fDBc13d4dF4A8c7',
    [ChainId.OPTIMISM]: '0x94b008aa00579c1307b0ef2c499ad98a8ce58e58',
    [ChainId.ARBITRUM]: '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9',
    [ChainId.POLYGON]: '0xc2132d05d31c914a87c6611c10748aeb04b58e8f',
    [ChainId.ETHEREUM]: '0xdac17f958d2ee523a2206206994597c13d831ec7'
  }
}, {
  name: 'dai',
  networks: [ChainId.BASE, ChainId.BSC, ChainId.AVALANCHE, ChainId.OPTIMISM, ChainId.ARBITRUM, ChainId.POLYGON, ChainId.ETHEREUM],
  tokens: {
    [ChainId.BASE]: '0x50c5725949A6F0c72E6C4a641F24049A917DB0Cb',
    [ChainId.BSC]: '0x1af3f329e8be154074d8769d1ffa4ee058b1dbc3',
    [ChainId.AVALANCHE]: '0xd586E7F844cEa2F87f50152665BCbc2C279D8d70',
    [ChainId.OPTIMISM]: '0xda10009cbd5d07dd0cecc66161fc93d7c9000da1',
    [ChainId.ARBITRUM]: '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1',
    [ChainId.POLYGON]: '0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063',
    [ChainId.ETHEREUM]: '0x6b175474e89094c44da98b954eedeac495271d0f'
  }
}];